(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  const initHeader = (header) => {
    const search = header.querySelector('[data-bmc-search]');
    const searchInput = header.querySelector('[data-omega-search-input]');
    const searchTriggers = [...header.querySelectorAll('[data-bmc-search-trigger]')];
    const searchClose = header.querySelector('[data-bmc-search-close]');
    const megaMenus = [...header.querySelectorAll('[data-bmc-mega-menu]')];
    const mobileDrawer = header.querySelector('#Details-menu-drawer-container');
    let closeTimer;
    let searchWasOpenBeforeDrawer = false;

    const hideOmegaAutocomplete = () => {
      document.querySelectorAll('.omega__autocomplete').forEach((panel) => {
        panel.classList.add('bmc-omega-autocomplete-hidden');
        panel.setAttribute('aria-hidden', 'true');
      });
    };

    const revealOmegaAutocomplete = () => {
      document.querySelectorAll('.omega__autocomplete').forEach((panel) => {
        panel.classList.remove('bmc-omega-autocomplete-hidden');
        panel.removeAttribute('aria-hidden');
      });
    };

    const hideOmegaClearControls = () => {
      const candidates = header.querySelectorAll(
        'button, a, [role="button"], span, i, svg, [class*="clear"], [class*="reset"], [class*="cancel"], [class*="close"]'
      );

      candidates.forEach((candidate) => {
        if (candidate === searchClose || candidate.closest('[data-bmc-search-close]')) return;
        if (candidate.closest('.bmc-header-search__icon')) return;

        const identity = [
          candidate.getAttribute('class'),
          candidate.getAttribute('id'),
          candidate.getAttribute('aria-label'),
          candidate.getAttribute('title'),
          candidate.parentElement?.getAttribute('class'),
          candidate.parentElement?.getAttribute('id'),
        ]
          .filter(Boolean)
          .join(' ');
        const text = candidate.children.length === 0 ? candidate.textContent.trim() : '';
        const isOmegaControl = /omega|(?:^|[-_\s])os(?:[-_\s]|$)/i.test(identity);
        const isClearControl = /clear|reset|cancel|close/i.test(identity) || text === '×' || text === '✕';

        if (isOmegaControl && isClearControl) {
          candidate.classList.add('bmc-omega-clear-hidden');
          candidate.setAttribute('aria-hidden', 'true');
        }
      });
    };

    const clearAndCloseSearch = () => {
      if (!searchInput) return;
      searchInput.value = '';
      searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      searchInput.dispatchEvent(new Event('change', { bubbles: true }));
      window.requestAnimationFrame(hideOmegaAutocomplete);
      if (!desktopQuery.matches && mobileDrawer?.open) {
        setSearchState(true, true);
        return;
      }
      setSearchState(false);
    };

    const closeMegaMenus = (except = null) => {
      megaMenus.forEach((menu) => {
        if (menu === except) return;
        menu.classList.remove('bmc-mega-menu--open');
        menu.querySelector('[data-bmc-mega-trigger]')?.setAttribute('aria-expanded', 'false');
      });
    };

    const openMegaMenu = (menu) => {
      if (!desktopQuery.matches) return;
      window.clearTimeout(closeTimer);
      closeMegaMenus(menu);
      menu.classList.add('bmc-mega-menu--open');
      menu.querySelector('[data-bmc-mega-trigger]')?.setAttribute('aria-expanded', 'true');
    };

    const scheduleMegaClose = () => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => closeMegaMenus(), 140);
    };

    const setSearchState = (open, focus = false) => {
      if (!search || !searchInput) return;
      const isOpen = Boolean(open);

      search.classList.toggle('is-open', isOpen);
      header.classList.toggle('bmc-mobile-search-open', isOpen && !desktopQuery.matches);
      search.setAttribute('aria-hidden', String(!isOpen));
      searchInput.tabIndex = isOpen ? 0 : -1;
      searchTriggers.forEach((trigger) => trigger.setAttribute('aria-expanded', String(isOpen)));

      if (isOpen && focus) {
        window.requestAnimationFrame(() => searchInput.focus({ preventScroll: true }));
      }
    };

    megaMenus.forEach((menu) => {
      menu.addEventListener('pointerenter', () => openMegaMenu(menu));
      menu.addEventListener('pointerleave', scheduleMegaClose);
      menu.addEventListener('focusin', () => openMegaMenu(menu));
      menu.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!menu.contains(document.activeElement)) scheduleMegaClose();
        });
      });
    });

    searchTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        closeMegaMenus();
        setSearchState(true, true);
      });
    });

    searchClose?.addEventListener('click', clearAndCloseSearch);

    searchInput?.addEventListener('input', () => {
      revealOmegaAutocomplete();
      hideOmegaClearControls();
    });

    searchInput?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && desktopQuery.matches) {
        event.preventDefault();
        hideOmegaAutocomplete();
        setSearchState(false);
        searchTriggers.find((trigger) => trigger.offsetParent !== null)?.focus();
      }
    });

    mobileDrawer?.addEventListener('toggle', () => {
      if (mobileDrawer.open) {
        closeMegaMenus();
        searchWasOpenBeforeDrawer = search.classList.contains('is-open');
        setSearchState(true);
      } else if (!desktopQuery.matches) {
        setSearchState(searchWasOpenBeforeDrawer);
        if (!searchWasOpenBeforeDrawer) hideOmegaAutocomplete();
      }
      document.body.classList.toggle('bmc-mobile-menu-open', mobileDrawer.open);
    });

    document.addEventListener('pointerdown', (event) => {
      const isInsideOmegaAutocomplete = event
        .composedPath()
        .some((target) => target.classList?.contains('omega__autocomplete'));

      if (!header.contains(event.target) && !isInsideOmegaAutocomplete) {
        closeMegaMenus();
        if (desktopQuery.matches) {
          hideOmegaAutocomplete();
          setSearchState(false);
        }
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeMegaMenus();
      if (desktopQuery.matches) {
        hideOmegaAutocomplete();
        setSearchState(false);
      } else if (!mobileDrawer?.open && search?.classList.contains('is-open')) {
        hideOmegaAutocomplete();
        setSearchState(false);
        searchTriggers.find((trigger) => trigger.offsetParent !== null)?.focus();
      }
      if (mobileDrawer?.open) mobileDrawer.open = false;
    });

    desktopQuery.addEventListener('change', () => {
      closeMegaMenus();
      setSearchState(false);
      if (desktopQuery.matches && mobileDrawer) mobileDrawer.open = false;
    });

    const omegaClearObserver = new MutationObserver(hideOmegaClearControls);
    omegaClearObserver.observe(header, { childList: true, subtree: true });

    // Cart section responses can still contain the legacy bare "CART" text.
    // Normalize replacements inside the existing link so its mobile CSS and
    // cart-drawer click listener continue to work after every cart update.
    const cartLink = header.querySelector('#cart-icon-bubble');
    if (cartLink) {
      const normalizeCartContent = () => {
        if (cartLink.querySelector('.bmc-cart__label')) return;

        const legacyCount = cartLink.querySelector('.cart-count-bubble span:not(.visually-hidden)');
        const hasLegacyText = Array.from(cartLink.childNodes).some(
          (node) => node.nodeType === Node.TEXT_NODE && /\bCART\b/i.test(node.textContent)
        );
        if (!legacyCount && !hasLegacyText) return;

        const count = legacyCount?.textContent.trim() || '0';
        const label = document.createElement('span');
        label.className = 'bmc-cart__label';
        label.textContent = 'Cart';

        const countElement = document.createElement('span');
        countElement.className = 'bmc-cart__count';
        countElement.textContent = count;

        const accessibleLabel = document.createElement('span');
        accessibleLabel.className = 'visually-hidden';
        accessibleLabel.textContent = (cartLink.dataset.cartLabelTemplate || 'View cart (__COUNT__)')
          .replace('__COUNT__', count);

        cartLink.replaceChildren(label, countElement, accessibleLabel);
      };

      const cartContentObserver = new MutationObserver(normalizeCartContent);
      cartContentObserver.observe(cartLink, { childList: true });
      normalizeCartContent();
    }

    hideOmegaClearControls();
    setSearchState(false);
  };

  const initialize = () => document.querySelectorAll('[data-bmc-header]').forEach(initHeader);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
